/* eslint-disable eqeqeq */
import { useState } from "react";
import ButtonField from "../../../../../components/buttonField/buttonField";
import { classNameBtn } from "../../../../../components/shared/button/types/buttonProps";
import { stylizationVerticalAlign } from "../../../../../components/shared/stylization";
import { FormFieldProps } from "../../../../../components/formField/types/formFieldProps";
import FormField from "../../../../../components/formField/formField";
import { TableTextEditRowProps } from "./types/tableTextEditRowProps";

const TableTextEditRow = (props: TableTextEditRowProps) => {
    const [value, setValue] = useState<string>(props.value);

    const inputProps: FormFieldProps = {
        inputPlaceholder: props.placeholder,
        type: "text",
        pristine: true,
        keepPristine: true,
        value: props.value,
        setValue: (event: any) => onChangeInput(event),
        style: { width: "100%" },
        className: "staticField"
    }

    const onChangeInput = (event: string) => {
        setValue(event);
    }

    const saveText = () => {
        props.onSave(value);
    }

    return (
        <div className="filefoldout">
            <FormField {...inputProps} />
            <ButtonField
                BtnProps={{
                    onClick: saveText,
                    className: `${classNameBtn.Btn} ${classNameBtn.LargeSecondary} body-txt-medium searchBtn`
                }}
                placeHolder={props.btnTitle}
                placeHolderStyle={stylizationVerticalAlign}
                wrapperProps={{ className: "searchBtnField" }}
            />
        </div>
    )
}

export default TableTextEditRow;